import { useMemo } from 'react';

export default function useDefinitions() {
  return useMemo(() => ({
    entityName: 'Integration',
    entityNamePlural: 'Integrations',
    entityNameModule: 'settings',
  }), [])
}
